/* eslint-disable react/prop-types */
import React from 'react'
import { SiteLayout } from '@jsluna/site-layout'
import { Sainsburys } from '@jsluna/images'
import { Header, HeaderLogo, HeaderNav } from '@jsluna/header'
import { PropTypes } from 'prop-types'
import { withRouter } from 'react-router-dom'
import SignOut from 'components/SignOut'
import isFeatureEnabled from '../../utils/features'
import '../../sass/components/header.scss'
import Feedback from '../Feedback'
import Constants from '../../utils/constants'

class HeaderComponent extends React.Component {
  componentDidMount() {
    window.addEventListener("popstate", () => {
      var pathArray = window.location.pathname.split('/');
      if(window.location.pathname === '/' || pathArray[1] === 'employers' ){
        this.props.setMenuSelectedState({ selectedMenu: '/employers' })
        this.closeMenu()
      }
    });
  }
  componentWillMount() {
    this.props.getPermissions()
    this.props.getFeatures()
  }

  handleToggle = () => {
    this.props.setMenuActiveState({ isOpen: !this.props.menuState.isOpen })
  }

  showMenu = (path, event) => {
    this.props.history.push(path)
    this.props.setMenuSelectedState({ selectedMenu: path })
    this.closeMenu()
    event.preventDefault()
  }

  handleEmployersSelection = (event) => {
    this.showMenu('/employers', event)
  }

  handleFireRollCallSelection = (event) => {
    this.showMenu('/firerollcall', event)
  }

  handleContractedHoursSelection = (event) => {
    this.showMenu('/contractedHours', event)
  }

  handlePassesSelection = (event) => {
    this.showMenu('/passes', event)
  }

  handleFeedbackSelection = (event) => {
    event.preventDefault()
    this.feedback.show()
  }

  canViewReportingMenu = () => {
    let isEnabled = false
    if (this.props.permissions.canViewReporting && this.props.features.features) {
      isEnabled = isFeatureEnabled(this.props.features.features, 'REPORTING')
    }
    return isEnabled
  }

  canViewPassesMenu = () => {
    let isEnabled = false
    if (this.props.permissions.canViewPasses && this.props.features.features) {
      isEnabled = isFeatureEnabled(this.props.features.features, 'PASSES')
    }
    return isEnabled
  }

  handleReportingSelection = (event) => {
    this.props.setSelectedReportType(0)
    this.showMenu('/reporting', event)
  }

  closeMenu = () => {
    if (this.props.menuState.isOpen) {
      this.props.setMenuActiveState({ isOpen: false })
    }
  }

  render() {
    const isMenuOpen = this.props.menuState.isOpen ? 'is-open' : ''
    const headerClassNames = `${isMenuOpen} ln-c-header`
    const isEmployerMenuSelected = this.props.menuSelectedState.selectedMenu === '/employers' ? 'is-active' : ''
    const employersMenuClassName = `${isEmployerMenuSelected} ln-c-list-group__item ln-c-header__nav-item`
    const isFireRollCallMenuSelected = this.props.menuSelectedState.selectedMenu === '/firerollcall' ? 'is-active' : ''
    const fireRollCallMenuClassName = `${isFireRollCallMenuSelected} ln-c-list-group__item ln-c-header__nav-item`
    const isContractedHoursSelected = this.props.menuSelectedState.selectedMenu === '/contractedHours' ? 'is-active' : ''
    const isReportingSelected = this.props.menuSelectedState.selectedMenu === '/reporting' ? 'is-active' : ''
    const isPassesSelected = this.props.menuSelectedState.selectedMenu === '/passes' ? 'is-active' : ''
    const contractedHoursMenuClassName = `${isContractedHoursSelected} ln-c-list-group__item ln-c-header__nav-item`
    const reportingMenuClassName = `${isReportingSelected} ln-c-list-group__item ln-c-header__nav-item`
    const passesMenuClassName = `${isPassesSelected} ln-c-list-group__item ln-c-header__nav-item`
    const canViewCompanies = this.props.permissions.canViewCompanies
    const canViewFireRollCall = this.props.permissions.canViewFireRollCall
    const canViewContractedHoursMenu = this.props.permissions.canViewContractedHours

    const getCompaniesMenu = () => {
      if (canViewCompanies) {
        return (
          <li>
            <a href="" className={employersMenuClassName} onClick={(event) => { this.handleEmployersSelection(event) }}>Companies and colleagues</a>
          </li>
        )
      }

      return ''
    }

    const getFireRollCallMenu = () => {
      if (canViewFireRollCall) {
        return (
          <li>
            <a href="" className={fireRollCallMenuClassName} onClick={(event) => { this.handleFireRollCallSelection(event) }}>Who&apos;s on site</a>
          </li>
        )
      }

      return ''
    }

    const getContractedHoursMenu = () => {
      if (canViewContractedHoursMenu) {
        return (
          <li>
            <a href="" className={contractedHoursMenuClassName} onClick={(event) => { this.handleContractedHoursSelection(event) }}>Contracted hours</a>
          </li>
        )
      }

      return ''
    }

    const getReportingMenu = () => {
      if (this.canViewReportingMenu()) {
        return (
          <li>
            <a href="" className={reportingMenuClassName} onClick={(event) => { this.handleReportingSelection(event) }}>Reporting</a>
          </li>
        )
      }

      return ''
    }

    const getPassesMenu = () => {
      if (this.canViewPassesMenu()) {
        return (
          <li>
            <a href="" className={passesMenuClassName} onClick={(event) => { this.handlePassesSelection(event) }}>Passes</a>
          </li>
        )
      }

      return ''
    }

    const getFeedbackMenu = () => {
      return (
        <li>
          <a href="" className='ln-c-list-group__item ln-c-header__nav-item' onClick={(event) => { this.handleFeedbackSelection(event) }}>Feedback</a>
        </li>
      )
    }

    const getHeaderMenu = () => (
      <ul className="ln-c-list-group ln-c-list-group--actionable ln-c-list-group--full ln-c-list-group--inline@nav ln-c-header__nav-list headerMenu">
        { getCompaniesMenu()}
        { getFireRollCallMenu()}
        { getContractedHoursMenu()}
        { getReportingMenu()}
        { getPassesMenu()}
        { getFeedbackMenu()}
      </ul>
    )

    return (
      <React.Fragment>
        <Feedback
          ref={(feedback) => { this.feedback = feedback }}
          appId={Constants.appId}
          headerText={'How was Digital Sign-in book admin?'}
          bodyText={'We want to know how you found using Digital Sign-in book admin today, so we can learn from your feedback and improve the tools you use.'}
        />
        <SiteLayout>
          <Header className={headerClassNames}>
            <div className="sainsbury">
              <Sainsburys
                className="sainsburysLogo"
                aria-label="Sainsbury's logo"
              />
              <div className="logOut"><SignOut /></div></div>
            <HeaderLogo>
              <div className="headerLogo">
                Digital Sign-in book admin
              </div>
            </HeaderLogo>
            <HeaderNav className="headerNav" openDropdownOnHover drawer label="Main">
              {getHeaderMenu()}
            </HeaderNav>
          </Header>
        </SiteLayout>
      </React.Fragment>
    )
  }
}

Header.propTypes = {
  menuState: PropTypes.shape({
    isOpen: PropTypes.bool
  }),
  setMenuActiveState: PropTypes.func,
  setMenuSelectedState: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  menuSelectedState: PropTypes.shape({
    selectedMenu: PropTypes.string
  }),
  permissions: PropTypes.shape({
    canViewCompanies: PropTypes.bool,
    canViewFireRollCall: PropTypes.bool,
    canViewReporting: PropTypes.bool,
    canViewPasses: PropTypes.bool,
    canViewContractedHours: PropTypes.bool
  }),
  getPermissions: PropTypes.func,
  getFeatures: PropTypes.func,
  features: PropTypes.shape({
    features: PropTypes.Array
  }),
  setSelectedReportType: PropTypes.func
}

Headers.defaultProps = {
  features: {
    features: []
  }
}
export default withRouter(HeaderComponent)



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx